import { render, staticRenderFns } from "./livePanel.vue?vue&type=template&id=04e070a6&scoped=true&"
import script from "./livePanel.vue?vue&type=script&lang=js&"
export * from "./livePanel.vue?vue&type=script&lang=js&"
import style0 from "./livePanel.vue?vue&type=style&index=0&id=04e070a6&lang=less&scoped=true&"
import style1 from "./livePanel.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e070a6",
  null
  
)

export default component.exports